import { render, staticRenderFns } from "./OrticInputControl.vue?vue&type=template&id=09556e44&"
import script from "./OrticInputControl.vue?vue&type=script&lang=js&"
export * from "./OrticInputControl.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports